import {convertToSearchParams, getFormattedSearchParams} from './getSearchParamsByGridCode';
import {getSourceSearchParams} from './getSourceSearchParams';

export const removeSearchParamsByGridCode = (gridCode: string) => {
  const formattedSearchParams = getFormattedSearchParams();

  if (!formattedSearchParams[gridCode]) {
    return;
  }

  delete formattedSearchParams[gridCode];

  const URL = window.location;
  const currentUrlWithoutSearchParams = URL.origin + URL.pathname;
  const sourceSearchParams = getSourceSearchParams();
  const sourceParams = sourceSearchParams ? `&${sourceSearchParams}` : '';

  const dataGridParams = new URLSearchParams(convertToSearchParams(formattedSearchParams));
  const hasRemainingDataGrids = Object.keys(formattedSearchParams).length > 0;
  const queryString = hasRemainingDataGrids ? `?${dataGridParams}${sourceParams}` : '';

  window.history.replaceState(null, '', currentUrlWithoutSearchParams + queryString);
};
